import { render, staticRenderFns } from "./group-setting.vue?vue&type=template&id=26c298a0&"
import script from "./group-setting.js?vue&type=script&lang=js&"
export * from "./group-setting.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports